<template>

  <section class="section">
    <div class="card mb-2">
      <div class="card-content has-background-grey-light has-text-black-bis">
        <h3 class="title">Geração de Boleto</h3>
        <h4 class="title is-4">{{ rsocial }}</h4>
      </div>
    </div>
    <div class="container-fuild">
      <div class="card">
        <div class="card-content has-background-white-ter has-text-dark">
          <div class="media">
            <div class="media-content">
              <div v-if="empresa == 'win'" class="container-fluid">
                <h5 class="mt-4 mb-4"><b>{{ rsocial }}</b></h5>
              </div>
              <div v-if="this.imgPreview" class="container-fluid">
                <img class="mt-4" :src="this.imgPreview" alt="Imagem pré visualização boleto" />
              </div>
              <p class="title is-4 mt-4">Número do Documento: {{ numeroDocumento }}</p>
              <p class="title is-6" v-if="email">Email: {{ email }}</p>
              <p class="title is-6" v-if="valor">Valor: {{ valor }}</p>

              <div v-if="empresa !== 'gocare'" class="py-5">
                <p class="title is-4">Linha digitável</p>
                <p class="title is-4">{{ linhaDigit }}</p>
              </div>

              <div v-if="empresa !== 'gocare'" class="title is-4 has-text-dark has-background-white py-5">
                <p class="title is-5">Código de Barras</p>
                <div class="">
                  <vue3-barcode format="ITF" :value="barcodeValue" :width="2" :height="100" tag="png" displayValue="false" />
                </div>
              </div>

              <div class="subtitle is-5 mt-5">
                  <a :href="'https://mail.api-mplan.com.br/boleto/gen/'+empresa+'/'+numdoc+'/'+sindicato+'/'+codtit" target="_blank" class="button is-primary"><b>Download do Boleto</b></a>
              </div>
            </div>
          </div>
          <div class="content">
            Confira sempre os dados do boleto antes de efetuar o pagamento.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue3Barcode from 'vue3-barcode'
import axios from 'axios';

// function codifica(data) {
//   var myStr = JSON.stringify(data);
//   var dadoCodificado = window.btoa(myStr);
//   return dadoCodificado
// }

function decodifica(data) {
  var myObjStr = window.atob(data);
  var dadoDecodificado = JSON.parse(myObjStr)
  return dadoDecodificado
}

export default {
  name: 'Boleto',
  data() {
    return {
      rsocial: '',
      empresa: '',
      numdoc: '',
      numeroDocumento: '',
      email: '',
      barcodeValue: '',
      linhaDigit: "",
      valor: '',
      sindicato: '',
      codtit: '',
      imgPreview: ''
    }
  },
  components: { Vue3Barcode },
  computed: {
    getUrl() {
      const url = this.$route.query.boleto;
      console(url)
      return url
    },
  },
  mounted() {
    const url_data = this.$route.query.boleto;
    const dadoDecodificado = decodifica(url_data)
    console.log(dadoDecodificado)
    this.email = dadoDecodificado.email
    this.rsocial = dadoDecodificado.rsocial
    this.empresa = dadoDecodificado.cliente.toLowerCase()
    this.numdoc = btoa(dadoDecodificado.numdoc)
    this.numeroDocumento = dadoDecodificado.numdoc
    this.valor = dadoDecodificado.valor
    this.barcodeValue = dadoDecodificado.codbar
    this.linhaDigit = dadoDecodificado.linhaDigit
    this.codfilial = dadoDecodificado.codfilial
    if (this.codfilial == undefined) { this.codfilial = 1 }
    if (dadoDecodificado.sindicato !== undefined) { this.sindicato = dadoDecodificado.sindicato }
    if (dadoDecodificado.codtit !== undefined) { this.codtit = dadoDecodificado.codtit }
    this.getImgPreview()
  },

  methods: {
    async getImgPreview() {
      const response = await axios.get(`https://planoonline.com.br:3005/preview/img/${this.empresa}`)
      this.imgPreview = response.data[0].img_preview
    }
  }
};
</script>
<style scoped></style>